import React, { useEffect, useState, useCallback } from 'react';
import { useAuth } from '../hooks/useAuthContext';
import { getMerenja } from '../utils/merenja';
import { klasifikujPritisak } from '../utils/helpers';
import FormaMerenja from '../components/FormaMerenja';
import TabelaMerenja from '../components/TabelaMerenja';
import GrafikonPritiska from '../components/GrafikonPritiska';

export default function Dashboard() {
  const { currentUser } = useAuth();
  const [merenja, setMerenja] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('tabela');

  const ucitajMerenja = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getMerenja(currentUser.uid);
      setMerenja(data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  }, [currentUser.uid]);

  useEffect(() => { ucitajMerenja(); }, [ucitajMerenja]);

  // Stats from last measurement
  const poslednje = merenja[0];
  const prosekSis = merenja.length
    ? Math.round(merenja.slice(0, 7).reduce((s, m) => s + m.sistolni, 0) / Math.min(merenja.length, 7))
    : null;
  const prosekDia = merenja.length
    ? Math.round(merenja.slice(0, 7).reduce((s, m) => s + m.dijastolni, 0) / Math.min(merenja.length, 7))
    : null;

  const poslednjiStatus = poslednje ? klasifikujPritisak(poslednje.sistolni, poslednje.dijastolni) : null;

  const ime = currentUser.displayName ? currentUser.displayName.split(' ')[0] : 'korisniče';

  return (
    <div className="main-content">
      <div className="dashboard-header">
        <h2>Dobro jutro, {ime}! 👋</h2>
        <p>Pratite krvni pritisak i čuvajte zdravlje svaki dan</p>
      </div>

      {/* Stats */}
      <div className="stats-grid">
        <div className={`stat-card ${poslednjiStatus?.statusKlasa || ''}`}>
          <div className="stat-label">Poslednji sistolni</div>
          <div className="stat-value">{poslednje?.sistolni ?? '—'}</div>
          <div className="stat-unit">mmHg (gornji)</div>
        </div>
        <div className={`stat-card ${poslednjiStatus?.statusKlasa || ''}`}>
          <div className="stat-label">Poslednji dijastolni</div>
          <div className="stat-value">{poslednje?.dijastolni ?? '—'}</div>
          <div className="stat-unit">mmHg (donji)</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Prosek (7 dana)</div>
          <div className="stat-value" style={{ fontSize: '1.3rem' }}>
            {prosekSis ? `${prosekSis}/${prosekDia}` : '—'}
          </div>
          <div className="stat-unit">mmHg</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Ukupno merenja</div>
          <div className="stat-value">{merenja.length}</div>
          <div className="stat-unit">unosa</div>
        </div>
        {poslednje?.puls && (
          <div className="stat-card">
            <div className="stat-label">Poslednji puls</div>
            <div className="stat-value">{poslednje.puls}</div>
            <div className="stat-unit">bpm</div>
          </div>
        )}
      </div>

      {/* Main grid */}
      <div className="dashboard-grid">
        {/* Form */}
        <div>
          <FormaMerenja onDodato={ucitajMerenja} />
        </div>

        {/* Records + Chart */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {/* Tab switch */}
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              className={`btn btn-sm ${activeTab === 'tabela' ? 'btn-primary' : 'btn-ghost'}`}
              onClick={() => setActiveTab('tabela')}
            >
              📅 Tabela
            </button>
            <button
              className={`btn btn-sm ${activeTab === 'grafikon' ? 'btn-primary' : 'btn-ghost'}`}
              onClick={() => setActiveTab('grafikon')}
            >
              📈 Grafikon
            </button>
          </div>

          {loading ? (
            <div className="loading-center"><div className="spinner" /></div>
          ) : activeTab === 'tabela' ? (
            <TabelaMerenja merenja={merenja} onObrisano={ucitajMerenja} />
          ) : (
            <GrafikonPritiska merenja={merenja} />
          )}
        </div>
      </div>
    </div>
  );
}
